import { Button, Input } from 'antd'
import { useEffect, useState } from 'react'
import PSAIModal from '@PSAIComponents/PSAIModal'
import styles from './index.module.scss'

const ProductInfoEditModal = ({
    open,
    value,
    onCancel,
    onSave,
    maxLength = 2000,
    onMaxLengthReach,
}) => {
    const [draftValue, setDraftValue] = useState(value || '')

    useEffect(() => {
        if (open) {
            setDraftValue(value || '')
        }
    }, [open, value])

    const handleBeforeInput = (event) => {
        const currentValue = String(draftValue || '')
        const insertedText = event?.data || ''
        const target = event?.target
        const selectionStart = target?.selectionStart ?? currentValue.length
        const selectionEnd = target?.selectionEnd ?? currentValue.length
        const nextLength = currentValue.length - (selectionEnd - selectionStart) + insertedText.length
        if (nextLength > maxLength) {
            onMaxLengthReach?.()
        }
    }

    const handlePaste = (event) => {
        const currentValue = String(draftValue || '')
        const pastedText = event?.clipboardData?.getData('text') || ''
        const target = event?.target
        const selectionStart = target?.selectionStart ?? currentValue.length
        const selectionEnd = target?.selectionEnd ?? currentValue.length
        const nextLength = currentValue.length - (selectionEnd - selectionStart) + pastedText.length
        if (nextLength > maxLength) {
            onMaxLengthReach?.()
        }
    }

    return (
        <PSAIModal
            open={open}
            title="编辑文本"
            maxWidth={848}
            okText="保存"
            cancelText="取消"
            footer={(
                <div className={styles.Footer}>
                    <Button className={styles.FooterButton} onClick={onCancel}>
                        取消
                    </Button>
                    <Button type="primary" className={styles.FooterButton} onClick={() => onSave?.(draftValue)}>
                        保存
                    </Button>
                </div>
            )}
            onCancel={onCancel}
            onOk={() => onSave?.(draftValue)}
        >
            <div className={styles.Content}>
                <Input.TextArea
                    value={draftValue}
                    onChange={(event) => setDraftValue(event.target.value)}
                    onBeforeInput={handleBeforeInput}
                    onPaste={handlePaste}
                    className={styles.Textarea}
                    autoSize={false}
                    maxLength={maxLength}
                    placeholder="请填写商品描述,如款式品类、工艺细节、适用场景等"
                />
            </div>
        </PSAIModal>
    )
}

export default ProductInfoEditModal
